export const home = {
  hero: {
    titleLine1: 'Pack the Lab In Your Pocket',
    titleLine2: 'Health On the Go',
    titleLine3: '',
    subtitle: 'ShanDouDou foodgogo is a cutting-edge health food brand backed by food science laboratories',
    description: '',
    ctaPrimary: 'Explore Products',
    ctaSecondary: 'Our Brand Story',
    card1: 'Gummies',
    card1Sub: 'Pocket Lab',
    card2: 'Freeze-Dried',
    card2Sub: 'Black Tech',
    card3: 'Herbal Bars',
    card3Sub: 'Punk Wellness',
  },
  products: {
    sectionTitle: 'Functional Nutrition Matrix',
    sectionDesc: 'Three product lines covering the full spectrum of light wellness — from pocket-sized micro-labs to nature-restoring black tech, and neo-Chinese punk wellness.',
    freezeDried: {
      category: 'Freeze-Dried Tonics',
      tag: 'Black Tech Series',
      name1: 'Freeze-Dried Tremella / Bird\'s Nest Soup',
      desc1: 'What used to take 4 hours of stewing now takes 60 seconds with hot water. FD freeze-drying locks in 98%+ of nutrients.',
      features1: ['FD Freeze-Drying', '60-Second Ready', '98% Nutrient Retention'],
      name2: 'Probiotic Freeze-Dried Powder',
      desc2: 'For gut health, paired with dietary fiber. Low-temperature cell-wall breaking technology for better absorption.',
      features2: ['Low-Temp Breaking', 'Dietary Fiber', 'Gut Health'],
      name3: 'Freeze-Dried Fruit Chips',
      desc3: 'Fig, yellow peach, and mulberry — medicinal food homology fruits. Preserving original shape and nutrition, the office snack of choice.',
      features3: ['Medicinal Food', 'Original Shape', 'Portable'],
    },
    gummies: {
      category: 'Functional Gummies',
      tag: 'Pocket Lab',
      name1: 'Late-Night Rescue Gummies',
      desc1: 'Ginseng, kudzu, and chrysanthemum extracts in microencapsulated form. Liver-protecting and eye-soothing. Zero sugar, zero fat, natural erythritol sweetener.',
      features1: ['Microencapsulation', 'Zero Sugar/Fat', 'Clean Label'],
      name2: 'Sleep Aid Gummies',
      desc2: 'Sour jujube seed, GABA, and lavender extracts. Eases insomnia and anxiety for lab-grade quality sleep every night.',
      features2: ['GABA Sleep Aid', 'Natural Jujube', 'Zero Sugar'],
    },
    energyBars: {
      category: 'Chinese Herbal Energy Bars',
      tag: 'Punk Wellness',
      name1: 'Black Sesame Balls Pro',
      desc1: 'With DHA algae oil and probiotics — nourish black with black. Calorie-control technology for precise energy management.',
      features1: ['DHA + Probiotics', 'Precise Calorie Control', 'Enzyme De-astringency'],
    },
    cta: 'View Details',
  },
  lab: {
    sectionLabel: 'LAB NOTES',
    sectionTitle: 'Cutting-Edge Extraction Tech',
    freezeDry: {
      title: '-40°C Freeze-Drying',
      stat: '-40°C',
      statLabel: 'Freeze Temp',
      description: 'FD freeze-drying sublimates moisture directly from solid to gas in a vacuum, preserving color, aroma, flavor, and active nutrients to the maximum extent.',
      badge: 'Core Tech Patent',
    },
    microEncapsulation: {
      title: 'Microencapsulation Targeting',
      stat: '98%',
      statLabel: 'Activity Retention',
      description: 'Encapsulating active ingredients to solve the bitter taste problem of traditional Chinese medicine, enabling precise nutrient release.',
      badge: 'Cold Extraction',
    },
    cleanLabel: {
      title: 'Clean Label Promise',
      stat: '0',
      statLabel: 'Chemical Additives',
      description: 'Rejecting excessive chemical additives. Nature is the best formulator; the lab\'s mission is to remove impurities and keep the essence.',
    },
  },
  about: {
    label: 'Brand Philosophy',
    title: 'Bring the Lab',
    titleLine2: 'Into Daily Life',
    description: 'ShanDouDou believes true green health is not blindly returning to the primitive, but using cutting-edge technology to restore nature\'s essence.\nWe source from 36 premium origins worldwide, find the purest green ingredients, and use advanced technology to precisely lock in their active nutrients.',
    manifesto: {
      label: 'Research Manifesto',
      text: 'Behind every product lies countless data tests and sensory refinements. We reject excessive chemical additives and uphold the clean label standard. In ShanDouDou\'s view, nature is the best formulator, and the lab\'s mission is to remove impurities and keep the essence.',
      founderName: 'ShanDouDou Lab',
      founderRole: 'Food Science R&D Team',
    },
    stats: [
      { number: '200+', label: 'Formula Iterations' },
      { number: '36', label: 'Global Origins' },
      { number: '0', label: 'Chemical Additives' },
      { number: '98%', label: 'Nutrient Retention' },
    ],
  },
  testimonials: {
    sectionLabel: 'Real Experiences',
    sectionTitle: 'Feedback from the Pocket',
    list: [
      { name: 'Lin Xiaoan', role: 'Product Manager', content: 'As a 996 worker, the late-night rescue gummies saved me. Used to drink coffee until heart palpitations; now two gummies keep me alert without the crash. Colleagues all want my recommendation.' },
      { name: 'Chen Mo', role: 'Yoga Instructor', content: 'Freeze-dried tremella soup is so convenient! Used to soak and stew for 2+ hours; now a 60-second morning brew with full collagen. Students all ask what I\'m eating.' },
      { name: 'Zhou Zhou', role: 'Grad Student', content: 'The sleep gummies got me through thesis season. Unlike melatonin, no dependency — the GABA + jujube combo wakes you up with a clear head.' },
      { name: 'Wang Dali', role: 'Fitness Coach', content: 'The upgraded black sesame balls with DHA + probiotics are thoughtful. Fitness folks need hair care too, and the high-protein plant jerky is guilt-free post-workout.' },
      { name: 'Su Su', role: 'Designer', content: 'Love the packaging aesthetics! Individual packs fit in any bag. The tangerine red bean cake works great for dampness relief — feeling much more energized.' },
    ],
  },
  cta: {
    title: 'Make Health No Longer a Static Wait',
    titleAccent: 'But a Dynamic Companion',
    description: 'Whether in an office cubicle or amidst mountains and lakes',
    descriptionAccent: 'ShanDouDou foodgogo',
    descriptionEnd: 'hopes to be the energy station in your pocket.',
    buttonText: 'Start Light Wellness Now',
  },
};